import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    width: '100%',
    height: '100%',
  },

  iconLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    color: '#FFFFFF',
    backgroundColor: '#424242',
    width: '10rem',
    padding: '0.5rem 0.25rem',
    borderRadius: '4px',
    fontSize: '12px',
  },
  
  issueContainer: {
    padding: '0 1.5rem',
  },
}))

export default styles
